(function($){
	$(function() {

		//place here your code
		
	});
})(jQuery);
